import { render, staticRenderFns } from "./ArticleInfoSocial.vue?vue&type=template&id=73816947&"
import script from "./ArticleInfoSocial.vue?vue&type=script&lang=ts&"
export * from "./ArticleInfoSocial.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleInfoSocial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports